<spinner></spinner>
<!-- nav -->
<nav class="navbar navbar-expand navbar-dark " style="background-color: #2a9292;" *ngIf="user">
  
    <!-- <div class="navbar-nav">
        <a class="navbar-brand" style="color: aliceblue;">Reports Dashboard</a>
        <a class="nav-item nav-link" routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" style="margin-left: 1rem;">Home</a>
         <a class="nav-item nav-link" routerLink="/users" routerLinkActive="active">Users</a> 
        <a class="nav-item nav-link" (click)="logout()" style="margin-left: 55rem;" >Logout</a>
    </div> -->
    <a class="navbar-brand" style="color: aliceblue;">Dashboard</a>
    <div class="collapse navbar-collapse" id="navbarNavDropdown">
        <ul class="navbar-nav">

          <li class="nav-item active">
            <a class="nav-link" routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}">Home</a>
          </li>

          <!-- <li class="nav-item active">
            <a class="nav-link" routerLink="/users" routerLinkActive="active">Users</a>
          </li> -->
          
          <li ngbDropdown  class="nav-item dropdown">
            <a ngbDropdownToggle class="nav-link dropdown-toggle"  id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              Reports
            </a>
            <div ngbDropdownMenu class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
              <a class="dropdown-item" routerLink="/reports/companyWiseCategorySales" routerLinkActive="active">Category Wise Sales Report</a>
              <a class="dropdown-item" routerLink="/reports/companyWiseSales" routerLinkActive="active">Sales Book Report </a>
              <a class="dropdown-item" routerLink="/reports/royaltyCharge" routerLinkActive="active">Royalty Charge Report</a>
              <a class="dropdown-item" routerLink="/reports/topSellingStore" routerLinkActive="active">Top Selling Store Report</a>
              <a class="dropdown-item" routerLink="/reports/companyWiseStock" routerLinkActive="active">Stock Report</a>




            </div>
          </li>

          <li ngbDropdown class="nav-item dropdown">
            <a ngbDropdownToggle class="nav-link dropdown-toggle" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              Master
            </a>
            <div ngbDropdownMenu class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
              <a class="dropdown-item" routerLink="/masters/productmaster" routerLinkActive="active">Product Master Requisition</a>

              <a class="dropdown-item" routerLink="/masters/rategroup" routerLinkActive="active">Rate Group Master</a>

            </div>
          </li>

          <li class="nav-item active">
            <a class="nav-link" routerLink="/users" routerLinkActive="active">Users</a>
          </li>

        </ul>
      </div>

      <a class="nav-item nav-link" (click)="logout()" style="margin-left: 48rem;color: aliceblue;" >Logout</a>

    
</nav>

<!--main app-->
<div class="app-container" [ngClass]="{ 'bg-light': user }">
    <alert></alert>
    <router-outlet></router-outlet>
</div>